import { useContext, useEffect, useState } from "react";
import { AppStateContext } from "../../context/AppContext";
import useApi from "../../hooks/useApi";
import {
  ListNotification,
  changeNotificationStatus,
} from "../../helper/API/API";
import useFilter from "../../hooks/useFilter";
import { CustomFilterDropdown } from "../../components/CustomFilter";

import {
  Button,
  DatePicker,
  Input,
  Modal,
  Space,
  Table,
  Row,
  Col,
  Card,
  Form,
  message,
  Select,
  Upload,
  InputNumber,
  Checkbox,
  Tabs,
  Dropdown,
  Tag,
} from "antd";
import {
  DeleteOutlined,
  MailOutlined,
  MoreOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { UploadOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import callApi from "../../helper/API/CallApi";
import { Severty, ShowToast } from "../../helper/toast";
import moment from "moment";
import { useDebouncedFunction } from "../../hooks/useDebounce";
import { uploadFileToS3 } from "../../helper/uploadImage";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import { t } from "i18next";
import { PencilIcon } from "lucide-react";
import LocationMapPicker from "../../components/LocationMapPicker";
const { confirm } = Modal;
const { RangePicker } = DatePicker;

const { TextArea } = Input;
const { Option } = Select;

function AdminManagement() {
  const { setPageHeading } = useContext(AppStateContext);
  setPageHeading("Admin Management");

  return (
    <div>
      <div className="page-inner-headding">
       
            <UserManagement />
          
      </div>
    </div>
  );
}

function UserManagement() {
  const { request } = useRequest();
  const [refresh, setRefresh] = useState(new Date().getTime());
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [totalDocs, setTotalDocs] = useState(0);
  const [userVisible, setUserVisible] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  const [filters, setFilters] = useFilter({
    sortField: "created_at",
    sort: "desc",
    page: 1,
    limit: 10,
  });

  const getUsers = async () => {
    try {
      setLoading(true);
      const query = new URLSearchParams();
      query.append("userType", "Admin");
      if (filters.page) query.append("page", filters.page);
      if (filters.limit) query.append("limit", filters.limit);
      if (filters.search) query.append("search", filters.search);
      if (filters.isActive !== undefined && filters.isActive !== "")
        query.append("isActive", filters.isActive);
      if (filters.startDate) query.append("start_date", filters.startDate);
      if (filters.endDate) query.append("end_date", filters.endDate);

      const url = `${apiPath.userList}?${query.toString()}`;
      request({
        url,
        method: "GET",
        onSuccess: ({ data }) => {
          setUserList(data?.list?.docs || []);
          setTotalDocs(data?.totalDocs || 0);
          setLoading(false);
        },
        onError: (err) => {
          ShowToast(err?.message || "Failed to fetch users", Severty.ERROR);
          setLoading(false);
        },
      });
    } catch (error) {
      ShowToast(error.message, Severty.ERROR);
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsers();
  }, [JSON.stringify(filters), refresh]);

  const confirmDeleteAdmin = (record) => {
    Modal.confirm({
      title: "Delete admin?",
      content: (
        <div>
          <p>
            Remove <strong>{record.name || record.email}</strong>? This will
            also delete all sub-admins and users under this admin.
          </p>
          <p style={{ marginBottom: 0 }}>This cannot be undone.</p>
        </div>
      ),
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk: () =>
        new Promise((resolve, reject) => {
          request({
            url: apiPath.deleteUser,
            method: "DELETE",
            data: { _id: record._id },
            onSuccess: ({ message: msg }) => {
              ShowToast(msg || "Admin deleted", Severty.SUCCESS);
              setRefresh(new Date().getTime());
              resolve();
            },
            onError: (err) => {
              ShowToast(err?.message || "Failed to delete admin", Severty.ERROR);
              reject(
                err instanceof Error
                  ? err
                  : new Error(err?.message || "Failed to delete admin")
              );
            },
          });
        }),
    });
  };

  const userColumns = [
    {
      title: "Employee ID",
      dataIndex: "suid",
      key: "suid",
      width: 130,
      ellipsis: true,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 120,
      ellipsis: true,
    },
    {
      title: "Mobile",
      dataIndex: "mobileNumber",
      key: "mobileNumber",
      width: 140,
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      width: 150,
      ellipsis: true,
      render: (location) => location || "—",
    },
    {
      title: "Strength",
      dataIndex: "strength",
      key: "strength",
      width: 80,
      align: "center",
    },
    {
      title: "Acceptable Limit (m)",
      dataIndex: "totalArea",
      key: "totalArea",
      width: 130,
      align: "center",
      render: (area) => (area != null ? area : "—"),
    },
    {
      title: "Validity",
      dataIndex: "validUntil",
      key: "validUntil",
      width: 130,
      render: (date) => {
        if (!date) return "—";
        const d = moment(date);
        const expired = d.isBefore(moment(), "day");
        return (
          <span style={expired ? { color: "#ff4d4f" } : {}}>
            {d.format("DD-MM-YYYY")}
            {expired && " (Expired)"}
          </span>
        );
      },
    },
    {
      title: "Status",
      key: "status",
      width: 90,
      align: "center",
      render: (_, record) => (
        <Tag
          color={record?.isActive ? "success" : "default"}
          style={{ cursor: "pointer", margin: 0 }}
          onClick={() => {
            request({
              url: apiPath.updateUserStatus,
              method: "PUT",
              data: { _id: record._id },
              onSuccess: ({ message: msg }) => {
                ShowToast(msg || "Status updated", Severty.SUCCESS);
                setRefresh(new Date().getTime());
              },
              onError: (err) => {
                ShowToast(err?.message || "Failed to update status", Severty.ERROR);
              },
            });
          }}
        >
          {record?.isActive ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    // {
    //   title: "Created At",
    //   dataIndex: "created_at",
    //   key: "created_at",
    //   render: (date) => (date ? moment(date).format("DD-MM-YYYY") : "-"),
    // },
    {
      title: "Actions",
      key: "action",
      width: 80,
      align: "center",
      render: (_, record) => (
        <Dropdown
          trigger={["click"]}
          menu={{
            items: [
              {
                key: "edit",
                label: "Edit",
                icon: <PencilIcon size={14} />,
                onClick: () => {
                  setEditingUser(record);
                  setUserVisible(true);
                },
              },
              {
                key: "email",
                label: "Email",
                icon: <MailOutlined />,
                onClick: () => {
                  Modal.info({
                    content: (
                      <div>
                        <p><strong>Name:</strong> {record?.name}</p>
                        <p><strong>Email:</strong> {record?.email || "Not available"}</p>
                      </div>
                    ),
                    okText: "Close",
                  });
                },
              },
              {
                key: "delete",
                label: "Delete",
                icon: <DeleteOutlined />,
                danger: true,
                onClick: () => confirmDeleteAdmin(record),
              },
            ],
          }}
        >
          <Button type="text" icon={<MoreOutlined />} aria-label="Actions" />
        </Dropdown>
      ),
    }
  ];

  const handleUserTableChange = ({ current, pageSize }) => {
    setFilters((prev) => ({ ...prev, page: current, limit: pageSize }));
  };

  const debouncedUserSearch = useDebouncedFunction((term) => {
    setFilters((prev) => ({ ...prev, search: term, page: 1 }));
  }, 500);

  const handleUserDateRange = (dates, dateStrings) => {
    const [startDate, endDate] = dateStrings;
    setFilters((prev) => ({ ...prev, startDate, endDate, page: 1 }));
  };

  return (
    <Row gutter={[24, 0]}>
      <Col xs={24} xl={24}>
        <Card bordered={false} className="criclebox tablespace mb-24 admin-management-card" title="Admin Management">
          <div className="tab_inner_tit">
            <div className="tab-upload-wrap d-flex align-items-center justify-content-between flex-wrap gap-2">
              <h3 className="mb-0">User List</h3>
              <div className="d-flex align-items-center gap-3 flex-wrap admin-toolbar-actions">
                <Input.Search
                  placeholder="Search by name"
                  className="searchInput admin-search-input"
                  onSearch={(v) => setFilters((p) => ({ ...p, search: v, page: 1 }))}
                  onChange={(e) => debouncedUserSearch(e.target.value)}
                  allowClear
                />
                <Button type="primary" icon={<PlusOutlined />} onClick={() => setUserVisible(true)}>
                  Add Admin
                </Button>
              </div>
            </div>
          </div>
          <div className="table-responsive customPagination admin-management-table-wrap">
            <Table
              className="admin-management-table"
              dataSource={userList}
              columns={userColumns}
              scroll={{ x: 920 }}
              tableLayout="fixed"
              size="middle"
              pagination={{
                pageSize: filters.limit,
                current: filters.page,
                total: totalDocs || 0,
                pageSizeOptions: [10, 20, 50, 100],
                showSizeChanger: true,
              }}
              onChange={handleUserTableChange}
              rowKey={(r) => r._id}
              loading={loading}
            />
          </div>
        </Card>
      </Col>
      <UserAddModal
        visible={userVisible}
        setVisible={setUserVisible}
        refresh={() => setRefresh(new Date().getTime())}
        editingUser={editingUser}
        setEditingUser={setEditingUser}
      />
    </Row>
  );
}

function UserAddModal({ visible, setVisible, refresh, editingUser, setEditingUser }) {
  const [loading, setLoading] = useState(false);
  const [profileFile, setProfileFile] = useState(null);
  const [form] = Form.useForm();
  const { request } = useRequest();

  useEffect(() => {
    if (visible && editingUser) {
      form.setFieldsValue({
        name: editingUser.name,
        email: editingUser.email,
        mobileNumber: editingUser.mobileNumber,
        userType: editingUser.userType || "user",
        locationData: {
          location: editingUser.location || "",
          latitude: editingUser.latitude,
          longitude: editingUser.longitude,
        },
        profilePic: editingUser.profilePic,
        isActive: editingUser.isActive !== false,
        strength: editingUser.strength ?? 0,
        totalArea: editingUser.totalArea || 100,
        suid: editingUser.suid,
        validUntil: editingUser.validUntil ? moment(editingUser.validUntil) : null,
      });
      if (editingUser.profilePic) {
        setProfileFile({
          uid: "-1",
          name: "profile",
          status: "done",
          url: editingUser.profilePic,
          thumbUrl: editingUser.profilePic,
        });
      } else setProfileFile(null);
    }
    if (!visible) {
      form.resetFields();
      setEditingUser && setEditingUser(null);
      setProfileFile(null);
    }
  }, [visible, editingUser]);

  const handleProfileUpload = async ({ file }) => {
    setLoading(true);
    try {
      const data = await uploadFileToS3({ file, dirName: "admin/users" });
      const url = data?.location || data?.Location || data?.LocationName || null;
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url,
        thumbUrl: url,
      };
      setProfileFile(fileData);
      form.setFieldsValue({ profilePic: url });
      return fileData;
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleOk = async (values) => {
    setLoading(true);
    const loc = values.locationData || {};
    const payload = {
      name: values.name,
      email: values.email,
      password: values.password,
      suid: values.suid,
      mobileNumber: values.mobileNumber || null,
      userType: values.userType || "user",
      location: loc.location || null,
      latitude: loc.latitude != null ? loc.latitude : undefined,
      longitude: loc.longitude != null ? loc.longitude : undefined,
      profilePic: values.profilePic || null,
      isActive: values.isActive !== false,
      strength: values.strength ?? 0,
      totalArea: values.totalArea || 100,
      validUntil: values.validUntil ? values.validUntil.format("YYYY-MM-DD") : null,
    };

    if (editingUser?._id) {
      payload._id = editingUser._id;
      if (values.newPassword?.trim()) payload.newPassword = values.newPassword;
      request({
        url: apiPath.updateUser,
        method: "PUT",
        data: payload,
        onSuccess: ({ message: msg }) => {
          ShowToast(msg, Severty.SUCCESS);
          form.resetFields();
          refresh();
          setVisible(false);
          setLoading(false);
        },
        onError: (err) => {
          ShowToast(err?.message || "Failed to update user", Severty.ERROR);
          setLoading(false);
        },
      });
    } else {
      request({
        url: apiPath.addUser,
        method: "POST",
        data: payload,
        onSuccess: ({ message: msg }) => {
          ShowToast(msg, Severty.SUCCESS);
          form.resetFields();
          refresh();
          setVisible(false);
          setLoading(false);
        },
        onError: (err) => {
          ShowToast(err?.message || err?.data?.message || "Failed to add user", Severty.ERROR);
          setLoading(false);
        },
      });
    }
  };

  const hide = () => {
    setVisible(false);
    form.resetFields();
    setProfileFile(null);
    setEditingUser && setEditingUser(null);
  };

  return (
    <Modal
      open={visible}
      title={editingUser ? "Edit User" : "Add Admin"}
      okText="Save"
      onCancel={hide}
      confirmLoading={loading}
      okButtonProps={{ form: "userForm", htmlType: "submit" }}
    >
      <Form id="userForm" form={form} onFinish={handleOk} layout="vertical">
      <Form.Item label="Employee ID" name="suid" disabled={!!editingUser}>
          <Input placeholder="Enter Employee ID" disabled={!!editingUser}/>
        </Form.Item>

        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please enter name!" }]}
        >
          <Input placeholder="Enter name" />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Please enter email!" },
            { type: "email", message: "Invalid email!" },
          ]}
        >
          <Input placeholder="Enter email" disabled={!!editingUser} />
        </Form.Item>
        {!editingUser ? (
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please enter password!" }]}
          >
            <Input.Password placeholder="Create password" />
          </Form.Item>
        ) : (
          <Form.Item label="New Password" name="newPassword">
            <Input.Password placeholder="Enter new password (optional)" />
          </Form.Item>
        )}
        <Form.Item label="Mobile" name="mobileNumber">
          <Input placeholder="Enter mobile number" />
        </Form.Item>
        <Form.Item label="Location" name="locationData" initialValue={{ location: "", latitude: undefined, longitude: undefined }}>
          <LocationMapPicker />
        </Form.Item>
        <Form.Item label="Strength" name="strength">
          <InputNumber min={0} style={{ width: "100%" }} placeholder="0" />
        </Form.Item>
        <Form.Item label="Acceptable Limit (out of location)" name="totalArea">
          <Select placeholder="Select acceptable limit" style={{ width: "100%" }}>
            {[100, 200, 300, 400, 500].map((value) => (
              <Select.Option key={value} value={value}>
                {value} meters
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Validity" name="validUntil" help="After this date, this Admin and their Sub-admins cannot login.">
          <DatePicker style={{ width: "100%" }} format="DD-MM-YYYY" allowClear />
        </Form.Item>
        <Form.Item name="isActive" valuePropName="checked" initialValue={true}>
          <Checkbox>Active</Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AdminManagement;
